"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetComponentName = void 0;
var _paulCorePackage = require("paul-core-package");
/** @todo add translations */
const useGetComponentName = function useGetComponentName() {
  let component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const tv = (0, _paulCorePackage.useTranslationValue)();
  if (component.type === _paulCorePackage.constants.ComponentTypes.PwcPoe) return 'Hauswasseranschluß';
  return tv(component.name);
};
exports.useGetComponentName = useGetComponentName;